<template>
    <v-card
        class="elevation-4 mx-auto"
        width="650"
    >
        
        <v-row class="pa-4">                    
            <v-col cols="8">
                <v-list>                            
                    <v-list-item-group v-model="menu">
                        <v-list-item
                            v-for="(item, i) in items"
                            :key="i"
                            @click="selectOption(item)"
                        >
                            <v-list-item-icon>
                                <v-icon 
                                    color="primary"
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title 
                                    :class="fontClass"
                                >
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list> 
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-center">
                <v-img
                    src="../assets/logo.jpg"
                    max-width="180"
                    contain
                    class="d-flex"
                ></v-img> 
            </v-col>
        </v-row>          
    </v-card>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name: 'MainMenu',
    data: () => ({
        items: [           
            {
                icon: 'mdi-keyboard',
                text: 'Enter Marks - Course Work',
                value: 'mark-book',
            },
            {
                icon: 'mdi-keyboard',
                text: 'Enter Marks - End of Term',
                value: 'enter-marks',
            },
            {
                icon: 'mdi-pencil',
                text: 'Edit/View Term Reports',
                value: 'term-reports',
            },
            // {
            //     icon: 'mdi-notebook-edit',
            //     text: 'Mark Book',
            //     value: 'mark-book'
            // }
        ],
        menu: '',
        step: 1,  
    }),
    computed: {
        ...mapGetters({
            user: 'auth/getEmployeeSignedIn',
            getMarkSheetLoading: 'termReports/getMarkSheetLoading',
            getEditViewTermReportsOverlay: 'termReports/getEditViewTermReportsOverlay',            
            id: 'auth/getEmployeeId',
        }),
        titleClass(){
            return 'subtitle-1 font-weight-light font-italic primary--text ';
        },
        cardTitleClass(){
            return 'py-2 pl-8 caption primary--text font-weight-bold text-uppercase secondary';
        },
        fontClass(){
            return 'font-weight-normal text-uppercase primary--text ';
        }
    },
    
    methods: {
        ...mapMutations({
            mainMenu: 'termReports/setMainMenu',
            enterMarks: 'termReports/setEnterMarks',
            editViewTermReports: 'termReports/setEditViewTermReports',
            welcomeMessage: 'termReports/setWelcomeMessage',
            markSheetOverlay: 'termReports/setMarkSheetOverlay',            
            markSheetLoading: 'termReports/setMarkSheetLoading',
            editViewTermReportsOverlay: 'termReports/setEditViewTermReportsOverlay',
            editViewTermReportsLoading: 'termReports/setEditViewTermReportsLoading',
            formClasses: 'termReports/setFormClasses',
            setFormClassesList: 'termReports/setFormClassesList',
            setFormTeacherClass: 'termReports/setFormTeacherClass',
            setMainMenuButton: 'termReports/setMainMenuButton',
            setMarkBook: 'markBook/setMarkBook',
            setDeanFormClasses: 'termReports/setDeanFormClasses',
            setWeeklyTest: 'weeklyTests/setWeeklyTest',
            setTermTest: 'termReports/setTermTest'
        }),

        ...mapActions({
            getFormClasses: 'termReports/getFormClasses',
            getFormTeacherClass: 'termReports/getAssignedFormTeacherClass',
            getCodedCommentsList: 'termReports/getCodedCommentsList',  
            getDeanFormClasses: 'termReports/getDeanFormClasses',
        }),

        async selectOption ({ value }) {
            this.setMainMenuButton(true); 
            this.mainMenu(false);
            this.displayMenuComponent(value);
            if(value === 'term-reports'){
                await this.setFormTeacherClasses(); 
                await this.mapDeanFormLevels();
            } 
        },

        displayMenuComponent (component) {
            let menuComponents = {
                'weekly-test' : this.setWeeklyTest,
                'enter-marks' : this.enterMarks,
                'term-reports' : this.editViewTermReports,
                'mark-book' : this.setMarkBook
            }
            Object.keys(menuComponents).forEach(key => {
                menuComponents[key](false);
                if(key === component){
                    menuComponents[key](true)
                }
            })
        },
        
        async mapDeanFormLevels () {
            try {
                const { data } = await this.getDeanFormClasses();
                this.setDeanFormClasses(data);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error)
            }
        },
        
        async setFormTeacherClasses(){
            try {
                const { data } = await this.getFormTeacherClass(this.id);
                this.setFormTeacherClass(data);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            
        },        
    }
}
</script>